import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import { fmtDashboardName } from "../../utils/format.util";
import { useAuthUser } from "../../hooks/useAuthUser";
import { YtdOrdersChart } from "./charts/YtdOrdersChart";
import { YtdPaymentsChart } from "./charts/YtdPaymentsChart";
import { AddPaymentMethod } from "../../components/Alerts/AddPaymentMethodAlert";

const useStyles = createStyles(() => ({
  container: {
    width: "100%",
    height: "100%",
    overflow: "auto",
    padding: tokens.spacing[20],
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[10],
  },
  header: {
    fontFamily: tokens.font.family.heading,
    "font-weight": tokens.font.weight.semibold,
    fontSize: tokens.font.size["3xl"],
    lineHeight: tokens.font.lineHeight.tight,
    color: tokens.color.semantic.text.bold,
  },
  trends: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[6],
  },
  trendsHeader: {
    fontFamily: tokens.font.family.sans,
    fontSize: tokens.font.size.lg,
    "font-weight": tokens.font.weight.bold,
    lineHeight: tokens.font.lineHeight.relaxed,
    color: tokens.color.semantic.text.subtle,
  },
  charts: {
    display: "flex",
    flexWrap: "wrap",
    gap: tokens.spacing[10],
  },
  chartCard: {
    flex: 1,
    padding: tokens.spacing[6],
    width: "100%",
    minWidth: 528,
    maxWidth: 528,
    height: 494,
    backgroundColor: tokens.color.primitive.base.white,
    borderRadius: tokens.radius.sm,
    boxShadow: tokens.shadow.raised,
  },
}));

const OrdersChartCard = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.chartCard}>
      <YtdOrdersChart />
    </div>
  );
};

const PaymentsChartCard = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.chartCard}>
      <YtdPaymentsChart />
    </div>
  );
};

export const DashboardView = () => {
  const user = useAuthUser();
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <span className={classes.header}>{`Welcome back, ${fmtDashboardName(user.dashboardUser)}!`}</span>
      <AddPaymentMethod />

      <div className={classes.trends}>
        <span className={classes.trendsHeader}>TRENDS</span>
        <div className={classes.charts}>
          <OrdersChartCard />
          {!user.isSandbox && <PaymentsChartCard />}
        </div>
      </div>
    </div>
  );
};
